import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  RequestGetEmpDto
} from '../dto/employees.dto';
import { NestApiProvider } from './../../nest-api';
import {
  RequestAttendanceStatisticsDto,
  RequestDownloadExcelDto,
  RequestDownloadPdfDto,
  RequestSendEmailExcelDto, RequestSendEmailPdfDto, ResponseAttendanceStatisticsDto, ResponseSendEmailExcelDto, ResponseSendEmailPdfDto
} from './../dto/attendance-report.dto';

@Injectable()
export class AttendanceReportApi {
  private service: string = '';
  private model: string = 'attendanceReport';
  private timeout: number = (5 * 60) * 1000;

  constructor(
    private nestApiProvider: NestApiProvider
  ) { }

  dowloadAttendanceStatistics(data: RequestAttendanceStatisticsDto): Observable<ResponseAttendanceStatisticsDto> {
    const method: string = 'POST';
    const func: string = 'dowloadAttendanceStatistics';
    const params: RequestAttendanceStatisticsDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseAttendanceStatisticsDto>(method, url, params, urlParams, body, null, this.timeout);
  }

  downloadExcel(data: RequestDownloadExcelDto) {
    const method: string = 'POST';
    const func: string = 'downloadExcel';
    const params: RequestDownloadExcelDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestBlob(method, url, params, urlParams, body);
  }

  downloadPdf(data: RequestDownloadPdfDto) {
    const method: string = 'POST';
    const func: string = 'downloadPdf';
    const params: RequestDownloadPdfDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestBlob(method, url, params, urlParams, body);
  }

  reportSendEmailExcel(data: RequestSendEmailExcelDto): Observable<ResponseSendEmailExcelDto> {
    const method: string = 'POST';
    const func: string = 'reportSendEmailExcel';
    const params: RequestSendEmailExcelDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSendEmailExcelDto>(method, url, params, urlParams, body, null, this.timeout);
  }

  reportSendEmailPdf(data: RequestSendEmailPdfDto): Observable<ResponseSendEmailPdfDto> {
    const method: string = 'POST';
    const func: string = 'reportSendEmailPdf';
    const params: RequestSendEmailPdfDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSendEmailPdfDto>(method, url, params, urlParams, body, null, this.timeout);
  }

  filterEmployee(payload: RequestGetEmpDto, queryParams: { page: number, limit: number }): Observable<any> {
    const method: string = 'POST';
    const func: string = 'filterEmployee';
    if (payload.active === '' || payload.active === null) {
      payload.active = '1'
    }
    const params: RequestGetEmpDto = payload;
    const urlParams: any = queryParams;
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }

  filterEmployeeClaimNew(payload: RequestGetEmpDto, queryParams: { page: number, limit: number }): Observable<any> {
    const method: string = 'POST';
    const model2: string = 'ClaimReport';
    const func: string = 'filterEmployee';
    const params: RequestGetEmpDto = payload;
    const urlParams: any = queryParams;
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, model2, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }

  filterEmployeeClaim(payload: any, queryParams: { page: number, limit: number }): Observable<any> {
    const method: string = 'POST';
    const model2: string = 'ClaimReport';
    const func: string = 'filterEmployee';
    const params: any = payload || {};
    const urlParams: any = queryParams;
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, model2, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }
}


// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/attendance-report.api.ts